export default [
  {
    path: '/account/addresses',
    exact: true,
    screenName: 'addressManager',
    contentType: 'others',
  },
  {
    path: '/my/address-book',
    exact: true,
    screenName: 'addressManager',
    contentType: 'others',
  },
  {
    path: '/account',
    exact: true,
    screenName: 'accountManager',
    contentType: 'others',
  },
  {
    path: '/account/orders/:orderId',
    exact: true,
    screenName: 'orderDetail',
    contentType: 'others',
  },
  {
    path: '/account/orders',
    exact: true,
    screenName: 'orderList',
    contentType: 'others',
  },
  {
    path: /.*-\d+.cat/,
    exact: true,
    screenName: 'categoryListProduct',
    contentType: 'product_category',
  },
  {
    path: '/checkout',
    exact: true,
    screenName: 'confirmOrder',
    contentType: 'checkout',
  },
  {
    path: '/confirm-payment/:orderId',
    exact: true,
    screenName: 'confirmPayment',
    contentType: 'others',
  },
  {
    path: '/p/:slug',
    exact: true,
    screenName: 'landingPage',
    contentType: 'others',
  },
  {
    path: '/',
    exact: true,
    screenName: 'homePage',
    contentType: 'homepage',
  },
  {
    path: '/login',
    exact: true,
    screenName: 'loginMethod',
    contentType: 'others',
  },
  {
    path: '/order-result',
    exact: true,
    screenName: 'orderResult',
    contentType: 'checkout',
  },
  {
    path: /.*-s([\w.\-]{1,20})\.html/,
    exact: true,
    screenName: 'productDetail',
    parser: (url: string) => {
      // extract skuId from url
      const urlArray = url.split('-s');
      const skuPart = urlArray[urlArray.length - 1];
      const result = skuPart.match(/([\w.\-]{1,20})\.html/);
      return {
        skuId: result && result[1] ? result[1] : null,
      };
    },
    contentType: 'product_detail',
  },
  {
    path: /.*--s([\w.\-]{1,20})/,
    exact: true,
    screenName: 'productDetail',
    parser: (url: string) => {
      const result = url.match(/--s([\w.\-]{1,20})/);
      return {
        skuId: result && result[1] ? result[1] : null,
      };
    },
    contentType: 'product_detail',
  },
  {
    path: '/search',
    exact: true,
    screenName: 'searchProductResult',
    contentType: 'product_category',
  },
  {
    path: '/buildpc',
    exact: true,
    screenName: 'buildPCSelfBuild',
    contentType: 'others',
  },
  {
    path: '/auth/vnpay/login',
    exact: true,
    screenName: 'loginMethod',
    contentType: 'others',
  },
  {
    path: '/cart',
    exact: true,
    screenName: 'cart',
    contentType: 'checkout',
  },
  {
    path: /.*-brand\..*/,
    exact: true,
    screenName: 'brandPage',
    contentType: 'other',
  },
  {
    path: /.*-sel\.\d+/,
    exact: true,
    screenName: 'sellerPage',
    contentType: 'other',
  },
  {
    path: '/cua-hang/:providerId',
    exact: true,
    screenName: 'providerPage',
    contentType: 'other',
  },
  {
    path: /.*-cat\.\d+/,
    exact: true,
    screenName: 'masterCategory',
    contentType: 'other',
  },
  {
    path: /.*-scat\..*/,
    exact: true,
    screenName: 'sellerCategory',
    contentType: 'other',
  },
  {
    path: '/landing/:slug',
    exact: true,
    screenName: 'landingPage',
    contentType: 'other',
  },
];
